// extracted by mini-css-extract-plugin
export var content = "_mo-1";
export var divider = "_mo-0";